const permissionConfig = [
  {
    role: "SuperAdmin",
    show: ["Settings", "Work List", "Marketing", "Blog Categories", "Blog Posts","Subscription"],
    // SuperAdmin can access all paths
    allowedPaths: [],
  },
  {
    role: "Client",
    show: ["Onboarding", "Settings"],
    allowedPaths: [
      "/onboarding",
      "/my-plan",
      "/settings/my-plan",
      "/agreement",
      "/settings/agreement",
      "/settings/sitedata",
    ],
  },
  {
    role: "Admin",
    show: ["Onboarding", "Subscription", "Settings"],
    allowedPaths: [
      "/onboarding",
      "/my-plan",
      "/settings/my-plan",
      "/agreement",
      "/settings/agreement",
      "/subscription",
      "/subscription/manage-subscriptions", 
      "/settings/sitedata",
    ],
  },
  {
    role: "Customer",
    show: [],
    allowedPaths: [],
  },
];
 
export default permissionConfig;
